<template>
  <div>
    <!--TODO tooltips-->
    <fin-add-to-watchlist :addToWatchlist="addToWatchlist"
                          :selected-instruments="[instrument]"
                          @closeAddToWatchlist="addToWatchlist = false"/>

    <!--TODO just send event instead of routing-->
    <v-btn :to="isShare ? {name: 'addCompanyPageInstrumentToPortfolio'} : {name: 'addEtfToPortfolio', params: {assetClassId: instrument.assetClass}}"
           :color="$finColors.primaryDark"
           class="mr-4"
           dark>
      Zu Portfolio hinzufügen
    </v-btn>

    <!--TODO maybe create actions menu component that can salso used datatable cellvalues -->
    <v-menu
      v-if="actions && actions.length"
      :left="true" :offset-y="true" rounded="0">
      <template #activator="{ on }">
        <v-btn :color="$finColors.primaryDark"
               icon
               outlined
               tile
               v-on="on">
          <v-icon>icon-contextmenu</v-icon>
        </v-btn>
      </template>

      <v-list style="border-radius: unset">

        <v-list-item v-for="(action, index) in actions" @click="action.click(instrument)" :key="index">
          <v-list-item-title v-if="action.enabled()">
              <v-icon v-if="action.icon" :color="$finColors.primaryDark" class="mr-3">{{ action.icon }}</v-icon>
              {{ action.name }}
          </v-list-item-title>
          <v-list-item-title v-else>
            <fin-subscription-lock color="fin-color-primary-dark"/>
            {{ action.name }}
          </v-list-item-title>
        </v-list-item>

        <v-list-item @click="addToWatchlist=true">
          <v-list-item-title>
            <v-icon :color="$finColors.primaryDark" class="pr-3">icon-eye</v-icon>
            Auf Watchlist setzen
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-btn v-else :color="$finColors.primaryDark"
           @click="addToWatchlist=true"
           icon
           outlined
           tile>
      <v-icon>icon-eye</v-icon>
    </v-btn>

  </div>
</template>
<script>
import FinAddToWatchlist from "@/components/common/Watchlists/AddToWatchlist"
import FinSubscriptionLock from "@/components/common/subscription/lock"

export default {
  name: 'fin-instrument-contextmenu',
  components: {FinSubscriptionLock, FinAddToWatchlist},
  props: {
    instrument: {
      required: true
    },
    actions: {
      type: Array
    }
  },
  data: () => ({
    addToWatchlist: false
  }),
  computed: {
    isShare(){
      return !this.instrument.assetClass || this.instrument.assetClass === 'SHARE'
    }
  }
}
</script>
<style lang="scss" scoped>
.sub-line-value-title ::v-deep span {
  text-transform: uppercase !important;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.39;
  letter-spacing: normal;
  display: inline;
  margin-right: 8px;
}

::v-deep .subscription-lock-icon {
  margin-right: 12px !important;
}


</style>
